import { Context, ExtentContext } from "../../lib/context";
export class NavigationContext extends Context {
}
export class NavigationExtentContext extends ExtentContext {
}
export const is_navigation_context = (c) => {
    return typeof c.navigate == 'function';
};
